import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { TenantOnboardingService } from '../services/tenant-onboarding.service';

export const NOT_ONBOARDED_URL = '/notonboarded';

/** Sends users of a tenant that has not completed onboarding to the "module not available" page. */
export const requireOnboardedTenantGuard: CanActivateChildFn = () => {
  const router = inject(Router);
  const tenantOnboardingService = inject(TenantOnboardingService);

  return tenantOnboardingService
    .checkOnboarded()
    .pipe(map((onboarded) => (onboarded ? true : router.createUrlTree([NOT_ONBOARDED_URL]))));
};

/** Keeps users of an onboarded tenant away from the "module not available" page. */
export const redirectWhenTenantOnboardedGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tenantOnboardingService = inject(TenantOnboardingService);

  return tenantOnboardingService
    .checkOnboarded()
    .pipe(map((onboarded) => (onboarded ? router.createUrlTree(['/']) : true)));
};
